// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumOwnerReferenceKind } from './EnumOwnerReferenceKind';
import {
  EnumOwnerReferenceKindFromJSON,
  EnumOwnerReferenceKindFromJSONTyped,
  EnumOwnerReferenceKindToJSON,
  EnumOwnerReferenceKindToJSONTyped,
} from './EnumOwnerReferenceKind';

/**
 *
 * @export
 * @interface RequestOwnerIdentifier
 */
export interface RequestOwnerIdentifier {
  /**
   *
   * @type {string}
   * @memberof RequestOwnerIdentifier
   */
  identifier?: string;
  /**
   *
   * @type {EnumOwnerReferenceKind}
   * @memberof RequestOwnerIdentifier
   */
  kind?: EnumOwnerReferenceKind;
}

/**
 * Check if a given object implements the RequestOwnerIdentifier interface.
 */
export function instanceOfRequestOwnerIdentifier(
  value: object,
): value is RequestOwnerIdentifier {
  return true;
}

export function RequestOwnerIdentifierFromJSON(
  json: any,
): RequestOwnerIdentifier {
  return RequestOwnerIdentifierFromJSONTyped(json, false);
}

export function RequestOwnerIdentifierFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestOwnerIdentifier {
  if (json == null) {
    return json;
  }
  return {
    identifier: json['identifier'] == null ? undefined : json['identifier'],
    kind:
      json['kind'] == null
        ? undefined
        : EnumOwnerReferenceKindFromJSON(json['kind']),
  };
}

export function RequestOwnerIdentifierToJSON(
  json: any,
): RequestOwnerIdentifier {
  return RequestOwnerIdentifierToJSONTyped(json, false);
}

export function RequestOwnerIdentifierToJSONTyped(
  value?: RequestOwnerIdentifier | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    identifier: value['identifier'],
    kind: EnumOwnerReferenceKindToJSON(value['kind']),
  };
}
